import { __ } from '@wordpress/i18n';

import { verticalLineIcon, horizontalLineIcon } from './icons';

export const titleTag = [
	{ label: __('H1', 'slider'), value: 'h1' },
	{ label: __('H2', 'slider'), value: 'h2' },
	{ label: __('H3', 'slider'), value: 'h3' },
	{ label: __('H4', 'slider'), value: 'h4' },
	{ label: __('H5', 'slider'), value: 'h5' },
	{ label: __('H6', 'slider'), value: 'h6' },
	{ label: __('P', 'slider'), value: 'p' },
	{ label: __('Div', 'slider'), value: 'div' }
]

export const btnAlignOpt = [
	{ label: __('Left', 'smart-modal'), value: 'left' },
	{ label: __('Center', 'smart-modal'), value: 'center' },
	{ label: __('Right', 'smart-modal'), value: 'right' }
];

export const layouts = [
	{ label: __('Vertical', 'textdomain'), value: 'vertical', icon: verticalLineIcon },
	{ label: __('Horizontal', 'textdomain'), value: 'horizontal', icon: horizontalLineIcon }
];

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'textdomain') },
	{ name: 'style', title: __('Style', 'textdomain') }
];